import { Button, Group, PasswordInput, Stack, TextInput } from "@mantine/core";
import { useForm, schemaResolver } from "@mantine/form";
import { z } from "zod";

export interface ResetPasswordModel {
    oldPassword?: string,
    newPassword?: string,
    repeatNewPassword?: string,
}
export const ResetPasswordScheme = z.object({
    oldPassword: z.string(),
    newPassword: z.string(),
    repeatNewPassword: z.string(),
}).refine((data) => data.newPassword === data.repeatNewPassword, {
    message: '新密碼與重複密碼必須相同',
    path: ['repeatNewPassword'],
});
export function ResetPasswordForm(props: { initialValues?: ResetPasswordModel, onSubmit: (values: ResetPasswordModel) => void }) {
    const form = useForm<ResetPasswordModel>({
        initialValues: props.initialValues,
        validate: schemaResolver(ResetPasswordScheme),
    });
    return <form onSubmit={form.onSubmit(async (data) => {
        props.onSubmit?.(data)
    })}>
        <Stack>
            <PasswordInput
                required
                placeholder="舊密碼"
                radius="md"
                {...form.getInputProps('oldPassword')}
            />

            <PasswordInput
                required
                placeholder="新密碼"
                radius="md"
                {...form.getInputProps('newPassword')}
            />
            <PasswordInput
                required
                placeholder="重新輸入新密碼"
                radius="md"
                {...form.getInputProps('repeatNewPassword')}
            />
        </Stack>

        <Group justify="center" mt="xl">
            <Button type="submit" radius="md">
                確定
            </Button>
        </Group>
    </form>
}